import Header from "../ui/header/Header";
import HeaderSaleBanner from "../ui/header/HeaderSaleBanner";
import {useUser} from "../../context/UserContext";
import {useRouteLoaderData} from "react-router-dom";

export default function UserHeader() {
    const loaderData = useRouteLoaderData('root') as [string, string[]] | null;
    const loaderIdToken = loaderData ? loaderData[0] : '';
    const {idToken: contextIdToken} = useUser();
    const isLoggedIn = !!(loaderIdToken || contextIdToken);

    const loggedInTopItems = [
        {
            title: 'Panel',
            to: '/produkt'
        },
        {
            title: 'Blog',
            to: '/blog'
        },
        {
            title: 'Opinie',
            to: '/opinie'
        },
    ];

    const defaultTopItems = [
        {
            title: 'O nas',
            to: '/o-nas'
        },
        {
            title: 'Produkacja OS',
            to: '/platforma'
        },
        {
            title: 'Blog',
            to: '/blog'
        },
        {
            title: 'Opinie',
            to: '/opinie'
        },
    ];

    return (
        <>
            <HeaderSaleBanner/>
            <Header
                loaderId='root'
                useDarkTheme={true}
                topItems={isLoggedIn ? loggedInTopItems : defaultTopItems}
                dropdownItems={[
                    {
                        title: 'Moje Produkty',
                        to: '/produkt'
                    },
                    {
                        title: 'Ustawienia',
                        to: '/ustawienia'
                    },
                    {
                        title: 'Statystyki',
                        to: '/statystyki'
                    },
                    // {
                    //     title: 'Ranking',
                    //     to: '/ranking'
                    // }
                ]}
            />
        </>
    );
}
